// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1o_II","signatureButtonsRight":"ModalSign_signatureButtonsRight__QEeen"};